import { mutations, getters, actions } from '@js/configs/ratesTableMethods'

const ratesTableModule = {
    state: {
        loanPurpose: {
            value: null,
        },
        loanAmount: {
            value: null,
        },
        creditRating: {
            value: null,
        },
        state: {
            value: null,
        },
        searching: false,
        sortOptionLists: {
            // field = false to ignore (eligibility default ordering)
            default: [
                { name: 'results.sorting.apr', field: 'apr_range.min', active: true },
                { name: 'results.sorting.loanAmount', field: 'loan_range.min', active: false },
                { name: 'results.filtering.term', field: 'term_range.min', active: false },
            ],
            creditCardOnly: [
                { name: 'results.sorting.apr', field: 'lender_rapr', active: true },
                { name: 'results.sorting.loanAmount', field: 'loan_range.min', active: false },
                { name: 'results.sorting.promoDuration', field: 'term_range.min', active: false },
            ],
        },
    },
    mutations,
    getters,
    actions,
}

export default ratesTableModule
